/**
 * @file useRecentColors.ts
 * @description «Последние» цвета окна «Свой цвет» текущего магазина
 * (phase19.16, партия SB120; uiux-sb120-fields §3). Магазин — из активного
 * кабинета (`useActiveShopId`); вне провайдера (тесты, превью) память общая,
 * без магазина (`commora.recent.colors`).
 */

import { useCallback, useState } from "react";

import { useActiveShopId } from "./useActiveShopId";
import { pushRecentColor, readRecentColors } from "../../lib/site-fields/recent-memory";

export interface RecentColorsApi {
  recent: string[];
  /** Запомнить цвет: новое — в начало, без повторов. */
  remember: (hex: string) => void;
}

export function useRecentColors(): RecentColorsApi {
  const shopId = useActiveShopId();
  // Читаем при монтировании окна: тело монтируется при каждом открытии.
  const [recent, setRecent] = useState(() => readRecentColors(shopId));
  const remember = useCallback((hex: string) => setRecent(pushRecentColor(shopId, hex)), [shopId]);
  return { recent, remember };
}
